// extracted by mini-css-extract-plugin
module.exports = {"tabList":"Tabs_tabList__KmZg9","tab":"Tabs_tab__XsoW8"};